
/**
 * SEO utilities for multilingual site optimization
 */

/**
 * Helper function to add language alternate links for multilingual SEO
 */
export const updateLanguageAlternateLinks = (baseUrl?: string, currentLang?: string): void => {
  if (!baseUrl) return;
  
  // Remove existing alternate links
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());
  
  // Extract the base URL without language
  const urlParts = baseUrl.split('/');
  let baseUrlNoLang = '';
  
  if (urlParts.length >= 4) {
    // Remove the language part and reconstruct
    urlParts.splice(3, 1);
    baseUrlNoLang = urlParts.join('/');
  } else {
    baseUrlNoLang = baseUrl.replace(/\/(de|en|fr|it)($|\/)/, '/');
  }
  
  // Add alternate links for each language
  const languages = ['de', 'en', 'fr', 'it'];
  languages.forEach(lang => {
    // Skip adding the link for the current language
    if (lang === currentLang) return;
    
    const hrefLangUrl = baseUrlNoLang.replace(/^(https?:\/\/[^\/]+)\//, `$1/${lang}/`);
    const link = document.createElement('link');
    link.setAttribute('rel', 'alternate');
    link.setAttribute('hreflang', lang);
    link.setAttribute('href', hrefLangUrl);
    document.head.appendChild(link);
  });
};
